import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("auth", ["user", "identification", "identificationType"]),
  },
  methods: {
    trackEvent({ eventCategory, eventAction, eventLabel, name_Screen, name_User }) {
      if (typeof window === "undefined") return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "FARMADOMICILIOS",
        eventCategory,
        eventAction,
        eventLabel,
        name_Screen,
        user_name: name_User || "",
        user_ID: this.identification || "",
        user_mail: this.user && this.user.email ? this.user.email : "",
        user_phone: this.user && this.user.phone ? this.user.phone : "",
        user_birth: this.user && this.user.birthDate ? this.user.birthDate : "",
      });
    },
  },
};
